import * as React from "react";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    width,
    adminSettings,
    lapiincons,
    exportFilePDF,
    logout,
    filtre,
    user,
    color,
    link,
    exportCamera,
    upload,
    height,
    incidents,
    explorer,
    administration,
    supervision,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @name lodash
   * @name i18next
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <span className="iconSvgBreadCrumb">
      <div className="iconSvgInsider">
        {incidents && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99994 0C8.36405 0.339081 10.0392 1.89877 11.618 3.3691L15.4149 6.90537C15.7874 7.25437 16 7.74938 16 8.26916V17.1601C16 17.8477 15.9959 18.3514 15.9635 18.6496C15.9474 18.7987 15.9273 18.8778 15.9167 18.9137C15.8815 18.9252 15.8055 18.9454 15.6615 18.9623C15.3734 18.9959 14.8871 19 14.2222 19H13.3334C12.669 19 12.1822 18.9958 11.8941 18.9623C11.7501 18.9455 11.6736 18.9248 11.6389 18.9137C11.6278 18.8774 11.6083 18.7987 11.5921 18.6496C11.5595 18.3514 11.5556 17.8482 11.5556 17.1601V15.3201C11.5556 14.6318 11.5588 14.1029 11.507 13.6256C11.4552 13.1484 11.3355 12.6471 10.9601 12.2582C10.5847 11.8694 10.1003 11.7443 9.63894 11.6904C9.17754 11.6365 8.66587 11.6401 8 11.6401C7.33413 11.6401 6.82248 11.6365 6.36106 11.6904C5.89965 11.7443 5.41527 11.8694 5.03989 12.2582C4.66451 12.6471 4.54481 13.1484 4.49302 13.6256C4.44121 14.1029 4.4444 14.6318 4.4444 15.3201V17.1601C4.4444 17.8477 4.44032 18.3514 4.40794 18.6496C4.39176 18.7987 4.37174 18.8778 4.36107 18.9137C4.32594 18.9252 4.2499 18.9454 4.10586 18.9623C3.81777 18.9959 3.33151 19 2.66665 19H1.77775C1.11286 19 0.626635 18.996 0.338545 18.9623C0.194499 18.9454 0.118463 18.9252 0.0833339 18.9137C0.0726601 18.8778 0.0526404 18.7987 0.0364589 18.6496C0.00409247 18.3514 0 17.8476 0 17.1601V8.26916C0 7.74765 0.213806 7.25091 0.588546 6.90178C1.65318 5.91021 2.72652 4.91082 4.38199 3.36919L8.00006 9.19992e-05L7.99994 0Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {explorer && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 924 891"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M617.906 560.377H659.875L923.296 815.094L844.639 891L580.69 636.792V596.547L566.172 582.538C506.256 632.208 428.391 662.264 343.135 662.264C153.619 662.264 0 514.019 0 331.132C0 148.245 153.619 0 343.135 0C532.651 0 686.269 148.245 686.269 331.132C686.269 413.406 655.123 488.547 603.389 546.368L617.906 560.377ZM106.533 325.557C106.533 448.565 209.891 548.307 337.357 548.307C464.824 548.307 568.182 448.565 568.182 325.557C568.182 202.549 464.824 102.807 337.357 102.807C209.891 102.807 106.533 202.549 106.533 325.557Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {administration && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 651 651"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M635.613 268.641L562.731 254.287C557.923 238.284 551.501 222.833 543.555 208.121L584.118 147.274C589.159 139.709 588.166 129.637 581.734 123.205L527.795 69.2661C521.368 62.8342 511.291 61.8359 503.726 66.8821L442.879 107.445C428.167 99.4986 412.716 93.0766 396.713 88.2688L382.359 15.3869C380.596 6.44682 372.758 0 363.645 0H287.355C278.242 0 270.404 6.44682 268.641 15.3869L254.287 88.2688C238.284 93.0766 222.833 99.4986 208.121 107.445L147.274 66.8821C139.709 61.8408 129.632 62.8342 123.205 69.2661L69.2661 123.205C62.8342 129.637 61.8408 139.709 66.8821 147.274L107.445 208.121C99.4986 222.833 93.0766 238.284 88.2639 254.287L15.382 268.641C6.44682 270.404 0 278.242 0 287.355V363.645C0 372.758 6.44682 380.596 15.3869 382.359L88.2688 396.713C93.0766 412.716 99.4986 428.167 107.445 442.879L66.8821 503.726C61.8408 511.291 62.8391 521.363 69.2661 527.795L123.205 581.734C129.632 588.166 139.709 589.159 147.274 584.118L208.121 543.555C222.833 551.501 238.284 557.923 254.287 562.731L268.641 635.613C270.404 644.553 278.242 651 287.355 651H363.645C372.758 651 380.596 644.553 382.359 635.613L396.713 562.731C412.716 557.923 428.167 551.501 442.879 543.555L503.726 584.118C511.291 589.159 521.363 588.161 527.795 581.734L581.734 527.79C588.166 521.363 589.159 511.291 584.118 503.726L543.555 442.879C551.501 428.167 557.923 412.716 562.731 396.713L635.613 382.359C644.553 380.596 651 372.758 651 363.645V287.355C651 278.242 644.553 270.404 635.613 268.641Z"
              fill="#028DFF"
            />
            <path
              d="M325.5 153.85C230.854 153.85 153.85 230.854 153.85 325.5C153.85 420.146 230.854 497.15 325.5 497.15C420.146 497.15 497.15 420.146 497.15 325.5C497.15 230.854 420.146 153.85 325.5 153.85ZM325.5 459.006C251.883 459.006 191.994 399.117 191.994 325.5C191.994 251.883 251.883 191.994 325.5 191.994C399.117 191.994 459.006 251.883 459.006 325.5C459.006 399.117 399.117 459.006 325.5 459.006Z"
              fill="white"
            />
            <path
              d="M325.5 230.139C272.917 230.139 230.139 272.917 230.139 325.5C230.139 378.083 272.917 420.861 325.5 420.861C378.083 420.861 420.861 378.083 420.861 325.5C420.861 272.917 378.083 230.139 325.5 230.139ZM325.5 382.717C293.951 382.717 268.283 357.049 268.283 325.5C268.283 293.951 293.951 268.283 325.5 268.283C357.049 268.283 382.717 293.951 382.717 325.5C382.717 357.049 357.049 382.717 325.5 382.717Z"
              fill="white"
            />
          </svg>
        )}
        {supervision && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 511 511"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <path
                d="M283.688 22H227.312C210.4 22 199.125 33.275 199.125 50.1875V444.812C199.125 461.725 210.4 473 227.312 473H283.688C300.6 473 311.875 461.725 311.875 444.812V50.1875C311.875 33.275 300.6 22 283.688 22Z"
                fill="#028DFF"
              />
            </g>
            <g filter="url(#filter1_d)">
              <path
                d="M114.562 303.875H58.1875C41.275 303.875 30 315.15 30 332.062V444.812C30 461.725 41.275 473 58.1875 473H114.562C131.475 473 142.75 461.725 142.75 444.812V332.062C142.75 315.15 131.475 303.875 114.562 303.875Z"
                fill="#028DFF"
              />
            </g>
            <g filter="url(#filter2_d)">
              <path
                d="M452.812 162.938H396.438C379.525 162.938 368.25 174.212 368.25 191.125V444.812C368.25 461.725 379.525 473 396.438 473H452.812C469.725 473 481 461.725 481 444.812V191.125C481 174.212 469.725 162.938 452.812 162.938Z"
                fill="#028DFF"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="169.125"
                y="0"
                width="172.75"
                height="511"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="8" />
                <feGaussianBlur stdDeviation="15" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_d"
                x="0"
                y="281.875"
                width="172.75"
                height="229.125"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="8" />
                <feGaussianBlur stdDeviation="15" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter2_d"
                x="338.25"
                y="140.938"
                width="172.75"
                height="370.062"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="8" />
                <feGaussianBlur stdDeviation="15" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        )}
        {exportFilePDF && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 512 558"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M511.037 537.46V174.247C511.037 168.427 508.641 162.95 504.533 159.184L339.187 5.4769C335.421 2.05399 330.286 0 325.151 0H69.4295C58.1326 0 48.8896 9.24295 48.8896 20.5399V249.902C48.8896 261.199 58.1326 270.441 69.4295 270.441C80.7265 270.441 89.9694 261.199 89.9694 249.902V41.0798H298.791V198.552C298.791 209.849 308.034 219.092 319.331 219.092H466.533C467.56 219.092 468.929 219.092 469.956 218.75V516.92H89.9694V434.761C89.9694 423.464 80.7265 414.221 69.4295 414.221C58.1326 414.221 48.8896 423.464 48.8896 434.761V537.46C48.8896 548.757 58.1326 558 69.4295 558H490.497C501.794 558 511.037 548.757 511.037 537.46ZM339.871 62.3047L464.137 178.013H339.871V62.3047Z"
              fill="#028DFF"
            />
            <path
              d="M0.962891 338.908C0.962891 350.205 10.2058 359.448 21.5028 359.448H235.46L169.39 418.329C160.832 425.86 160.147 438.869 167.678 447.427C171.786 451.876 177.263 454.274 183.083 454.274C187.876 454.274 192.668 452.562 196.776 449.139L303.583 353.97C308.033 350.204 310.43 344.385 310.43 338.565C310.43 332.745 308.034 327.268 303.583 323.16L196.777 227.993C188.219 220.462 175.21 221.146 167.679 229.705C160.148 238.263 160.832 251.272 169.391 258.803L236.488 318.368H21.5028C10.2058 318.368 0.962891 327.611 0.962891 338.908Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {filtre && color && (
          <svg width={width} height={height} viewBox="0 0 40 40">
            <path
              fill={color}
              d="M37.213 29c0 0.373-0.293 0.667-0.667 0.667h-15.947c-0.227 1.253-1.307 2.213-2.613 2.213s-2.4-0.96-2.613-2.213h-12.373c-0.373 0-0.667-0.293-0.667-0.667s0.293-0.667 0.667-0.667h12.453c0.36-1.053 1.347-1.827 2.52-1.827s2.16 0.773 2.52 1.827h16.053c0.373 0 0.667 0.293 0.667 0.667zM36.547 19.147h-6.667c-0.36-1.053-1.347-1.827-2.52-1.827s-2.16 0.773-2.52 1.827h-21.84c-0.373 0-0.667 0.293-0.667 0.667s0.293 0.667 0.667 0.667h21.747c0.227 1.253 1.307 2.213 2.613 2.213s2.4-0.96 2.613-2.213h6.56c0.373 0 0.667-0.293 0.667-0.667s-0.28-0.667-0.653-0.667zM3 10.987h5.307c0.227 1.267 1.32 2.213 2.627 2.213s2.4-0.96 2.613-2.213h23c0.373 0 0.667-0.293 0.667-0.667s-0.293-0.667-0.667-0.667h-23.107c-0.347-1.053-1.333-1.827-2.507-1.827s-2.16 0.773-2.52 1.827h-5.413c-0.373 0-0.667 0.293-0.667 0.667s0.307 0.667 0.667 0.667z"
            />
          </svg>
        )}
        {logout && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M255.15 468.625H63.787C52.05 468.625 42.525 459.099 42.525 447.363V64.6376C42.525 52.9006 52.051 43.3756 63.787 43.3756H255.15C266.908 43.3756 276.412 33.8716 276.412 22.1136C276.412 10.3556 266.908 0.849609 255.15 0.849609H63.787C28.619 0.849609 0 29.4696 0 64.6376V447.362C0 482.53 28.619 511.149 63.787 511.149H255.15C266.908 511.149 276.412 501.645 276.412 489.887C276.412 478.129 266.908 468.625 255.15 468.625Z"
              fill="#028DFF"
            />
            <path
              d="M505.664 240.861L376.388 113.286C368.053 105.036 354.573 105.143 346.323 113.499C338.073 121.855 338.158 135.314 346.536 143.564L438.921 234.737H191.362C179.604 234.737 170.1 244.241 170.1 255.999C170.1 267.757 179.604 277.262 191.362 277.262H438.921L346.536 368.435C338.159 376.685 338.095 390.144 346.323 398.5C350.49 402.71 355.976 404.836 361.462 404.836C366.863 404.836 372.263 402.795 376.388 398.712L505.664 271.137C509.704 267.14 512 261.696 512 255.998C512 250.302 509.725 244.88 505.664 240.861Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {link && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 357 358"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M130.742 283.24L112.678 301.18C97.0192 316.7 71.5517 316.714 55.9017 301.18C48.378 293.714 44.2457 283.798 44.2457 273.258C44.2457 262.717 48.3824 252.797 55.8973 245.331L122.389 179.362C136.169 165.698 162.091 145.577 180.986 164.315C189.656 172.927 203.66 172.869 212.268 164.203C220.88 155.537 220.827 141.529 212.156 132.925C180.04 101.054 132.572 106.945 91.2314 147.964L24.7356 213.938C8.7822 229.775 0 250.838 0 273.258C0 295.677 8.7822 316.736 24.7401 332.573C41.1576 348.861 62.716 357.001 84.2832 357.001C105.855 357.001 127.422 348.861 143.849 332.564L161.926 314.621C170.592 306.017 170.642 292.014 162.029 283.343C153.43 274.681 139.413 274.632 130.742 283.24ZM332.251 26.9723C297.756 -7.25503 249.525 -9.11143 217.591 22.5723L195.074 44.925C186.403 53.5331 186.35 67.532 194.962 76.2027C203.575 84.8733 217.578 84.9224 226.249 76.3142L248.758 53.9749C265.3 37.5485 286.961 44.3582 301.089 58.375C308.622 65.8407 312.759 75.7609 312.759 86.3013C312.759 96.8462 308.618 106.766 301.098 114.232L230.158 184.606C197.72 216.789 182.503 201.684 176.01 195.24C167.339 186.632 153.34 186.685 144.728 195.351C136.115 204.018 136.169 218.025 144.839 226.629C159.731 241.409 176.728 248.736 194.547 248.736C216.364 248.736 239.409 237.75 261.32 215.995L332.26 145.621C348.209 129.784 357 108.716 357 86.2968C357 63.8861 348.209 42.8187 332.251 26.9723Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {upload && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 685 470"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M541.992 181C523.121 89.2 442.246 19 342.5 19C264.321 19 196.925 62.2 164.575 127C81.0042 137.8 19 205.3 19 289C19 378.1 91.7875 451 180.75 451H531.208C606.692 451 666 391.6 666 316C666 245.8 609.388 186.4 541.992 181Z"
              stroke="#028DFF"
              strokeWidth="38"
              strokeLinecap="square"
            />
            <path
              d="M396.7 263V371H288.3V263H207L342.5 128L478 263H396.7Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {user && color && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 564 537"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M280.79 301.144C364.056 301.144 431.593 233.606 431.593 150.341C431.593 67.076 364.055 0 280.79 0C197.525 0 129.987 67.538 129.987 150.341C129.987 233.144 197.524 301.144 280.79 301.144Z"
              fill={color}
            />
            <path
              d="M19.891 536.6H543.539C554.641 536.6 563.43 527.811 563.43 516.709C563.43 412.627 478.777 327.511 374.232 327.511H189.198C85.116 327.511 0 412.164 0 516.709C0 527.811 8.789 536.6 19.891 536.6Z"
              fill={color}
            />
          </svg>
        )}
        {exportCamera && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 606 492"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M601.398 36.2802C598.033 32.5684 593.256 30.4522 588.246 30.4522H555.401L557.6 24.1365C559.491 18.7074 558.635 12.6995 555.305 8.01361C551.976 3.32776 546.582 0.543945 540.834 0.543945H49.3783C44.3729 0.543945 39.5995 2.65666 36.2345 6.36368C32.8696 10.0695 31.2256 15.0228 31.7061 20.0058L48.1107 189.779C48.9901 198.88 56.6385 205.825 65.783 205.825H130.786V242.849C130.786 252.654 138.735 260.603 148.54 260.603H183.141V310.262H96.3611V264.562C96.3611 254.757 88.4121 246.808 78.6072 246.808H17.7539C7.94902 246.808 0 254.757 0 264.562V473.702C0 483.507 7.94902 491.456 17.7539 491.456H78.6072C88.4121 491.456 96.3611 483.507 96.3611 473.702V428.001H253.307C279.54 428.001 300.881 406.66 300.881 380.427V260.603H335.483C345.287 260.603 353.236 252.654 353.236 242.849V205.825H430.999C451.872 205.825 471.505 198.517 487.018 185.979C487.784 186.079 488.559 186.149 489.353 186.149H576.472C585.607 186.149 593.25 179.218 594.142 170.126L605.916 49.9365C606.404 44.9512 604.763 39.9907 601.398 36.2802ZM317.727 225.095H166.295V205.825H317.729V225.095H317.727ZM81.9047 170.317L77.1336 120.939H359.171C377.879 120.939 394.652 108.411 399.959 90.4722L416.062 36.0529H515.854L481.637 134.327C474.142 155.854 453.792 170.316 430.999 170.316H81.9047V170.317ZM68.9301 36.0529H379.032L365.909 80.3963C365.032 83.36 362.261 85.4301 359.17 85.4301H73.7012L68.9301 36.0529ZM60.8533 455.947H35.5078V282.315H60.8533V455.947ZM265.372 380.427C265.372 387.081 259.96 392.493 253.306 392.493H96.3611V345.77H200.895C210.7 345.77 218.649 337.821 218.649 328.016V260.603H265.372V380.427ZM560.372 150.641H513.392C514.021 149.116 514.624 147.575 515.171 146.003L543.039 65.9612H568.667L560.372 150.641Z"
              fill="#028DFF"
            />
          </svg>
        )}
        {adminSettings && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 776 787"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M595.861 787C496.346 787 415.721 706.302 415.721 606.697C415.721 507.092 496.346 426.24 595.861 426.24C672.34 427.931 738.836 479.578 759.108 553.513C761.258 562.274 755.883 571.19 747.129 573.342C738.376 575.494 729.469 570.114 727.319 561.352C710.272 502.327 657.136 461.133 595.861 458.981C514.468 458.981 448.432 525.076 448.432 606.543C448.432 688.01 514.468 754.106 595.861 754.106C604.922 754.106 612.293 761.484 612.293 770.553C612.293 779.622 604.922 787 595.861 787Z"
                fill="#028DFF"
              />
              <path
                d="M759.722 590.25H661.436C652.375 590.25 645.004 582.871 645.004 573.802C645.004 564.734 652.375 557.355 661.436 557.355H743.29V475.428C743.29 466.359 750.662 458.98 759.722 458.98C768.783 458.98 776.154 466.359 776.154 475.428V573.802C776.001 582.871 768.783 590.25 759.722 590.25Z"
                fill="#028DFF"
              />
              <path
                d="M657.443 126.504C648.996 111.594 630.875 104.985 614.903 111.133L533.663 143.873C518.46 132.96 502.335 123.43 485.288 115.744L473.002 29.3587C470.699 12.6042 456.109 -0.153768 439.063 -5.70985e-05H294.859C277.812 -0.153768 263.376 12.2968 260.919 29.205L248.48 115.744C231.433 123.584 215.308 132.96 200.105 143.873L118.711 111.133C102.893 104.831 84.9255 111.287 76.6326 126.197L4.60729 250.856C-3.99275 265.612 -0.460595 284.519 13.0538 295.125L81.8541 348.924C79.7041 367.523 79.7041 386.429 81.8541 405.182L13.0538 459.135C-0.153451 469.741 -3.68561 488.493 4.76086 503.25L76.6326 627.909C85.0791 642.819 103.201 649.275 119.172 643.127L200.412 610.386C215.615 621.3 231.894 630.83 248.941 638.515L261.226 724.747C263.53 741.655 277.966 754.413 295.166 754.26H407.734C416.795 754.26 424.166 746.881 424.166 737.812C424.166 734.431 423.091 731.203 421.249 728.436C396.216 692.775 382.855 650.197 382.855 606.697C382.855 586.1 385.927 565.656 391.763 545.981C393.298 540.909 392.223 535.375 388.845 531.225C385.62 526.921 380.398 524.615 375.177 525.077C373.334 525.077 371.645 525.384 367.191 525.999C285.644 526.153 219.301 460.057 218.994 378.436C218.687 296.816 284.876 230.413 366.423 230.105C447.97 229.798 514.313 296.047 514.62 377.668C514.62 378.744 514.62 379.666 514.62 380.742C514.313 382.433 514.16 384.277 514.006 386.122C513.545 395.191 520.456 402.876 529.517 403.337C531.36 403.491 533.203 403.184 535.045 402.723C567.142 392.885 601.081 391.041 633.946 397.343C638.553 397.804 643.314 396.42 646.846 393.346C650.532 390.272 652.989 385.814 653.45 380.896C653.45 380.435 653.603 377.668 653.603 377.207C653.603 367.83 652.989 358.454 652.067 349.078L721.021 295.279C734.229 284.673 737.914 265.92 729.314 251.164L657.443 126.504Z"
                fill="#028DFF"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width={width} height={height} fill="white" />
              </clipPath>
            </defs>
          </svg>
        )}
        {lapiincons && (
          <svg
            width={width}
            height={height}
            viewBox="0 0 64 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.27 6.088H12.076L16.388 16H13.924L13.07 13.9H9.22L8.394 16H5.986L10.27 6.088ZM11.11 8.972L9.906 12.052H12.328L11.11 8.972ZM20.6332 6.088H22.4392L26.7512 16H24.2872L23.4332 13.9H19.5832L18.7572 16H16.3492L20.6332 6.088ZM21.4732 8.972L20.2692 12.052H22.6912L21.4732 8.972ZM30.5204 13.354H27.0764V11.674H30.5204V13.354ZM31.3172 11.044C31.3172 10.456 31.3685 9.85867 31.4712 9.252C31.5832 8.64533 31.7745 8.09467 32.0452 7.6C32.3252 7.10533 32.7032 6.704 33.1792 6.396C33.6552 6.07867 34.2619 5.92 34.9992 5.92C35.7365 5.92 36.3432 6.07867 36.8192 6.396C37.2952 6.704 37.6685 7.10533 37.9392 7.6C38.2192 8.09467 38.4105 8.64533 38.5132 9.252C38.6252 9.85867 38.6812 10.456 38.6812 11.044C38.6812 11.632 38.6252 12.2293 38.5132 12.836C38.4105 13.4427 38.2192 13.9933 37.9392 14.488C37.6685 14.9827 37.2952 15.3887 36.8192 15.706C36.3432 16.014 35.7365 16.168 34.9992 16.168C34.2619 16.168 33.6552 16.014 33.1792 15.706C32.7032 15.3887 32.3252 14.9827 32.0452 14.488C31.7745 13.9933 31.5832 13.4427 31.4712 12.836C31.3685 12.2293 31.3172 11.632 31.3172 11.044ZM33.4172 11.044C33.4172 11.3053 33.4265 11.618 33.4452 11.982C33.4732 12.346 33.5385 12.696 33.6412 13.032C33.7439 13.368 33.8979 13.6527 34.1032 13.886C34.3179 14.1193 34.6165 14.236 34.9992 14.236C35.3725 14.236 35.6665 14.1193 35.8812 13.886C36.0959 13.6527 36.2545 13.368 36.3572 13.032C36.4599 12.696 36.5205 12.346 36.5392 11.982C36.5672 11.618 36.5812 11.3053 36.5812 11.044C36.5812 10.7827 36.5672 10.47 36.5392 10.106C36.5205 9.742 36.4599 9.392 36.3572 9.056C36.2545 8.72 36.0959 8.43533 35.8812 8.202C35.6665 7.96867 35.3725 7.852 34.9992 7.852C34.6165 7.852 34.3179 7.96867 34.1032 8.202C33.8979 8.43533 33.7439 8.72 33.6412 9.056C33.5385 9.392 33.4732 9.742 33.4452 10.106C33.4265 10.47 33.4172 10.7827 33.4172 11.044ZM39.5886 11.044C39.5886 10.456 39.6399 9.85867 39.7426 9.252C39.8546 8.64533 40.0459 8.09467 40.3166 7.6C40.5966 7.10533 40.9746 6.704 41.4506 6.396C41.9266 6.07867 42.5333 5.92 43.2706 5.92C44.0079 5.92 44.6146 6.07867 45.0906 6.396C45.5666 6.704 45.9399 7.10533 46.2106 7.6C46.4906 8.09467 46.6819 8.64533 46.7846 9.252C46.8966 9.85867 46.9526 10.456 46.9526 11.044C46.9526 11.632 46.8966 12.2293 46.7846 12.836C46.6819 13.4427 46.4906 13.9933 46.2106 14.488C45.9399 14.9827 45.5666 15.3887 45.0906 15.706C44.6146 16.014 44.0079 16.168 43.2706 16.168C42.5333 16.168 41.9266 16.014 41.4506 15.706C40.9746 15.3887 40.5966 14.9827 40.3166 14.488C40.0459 13.9933 39.8546 13.4427 39.7426 12.836C39.6399 12.2293 39.5886 11.632 39.5886 11.044ZM41.6886 11.044C41.6886 11.3053 41.6979 11.618 41.7166 11.982C41.7446 12.346 41.8099 12.696 41.9126 13.032C42.0153 13.368 42.1693 13.6527 42.3746 13.886C42.5893 14.1193 42.8879 14.236 43.2706 14.236C43.6439 14.236 43.9379 14.1193 44.1526 13.886C44.3673 13.6527 44.5259 13.368 44.6286 13.032C44.7313 12.696 44.7919 12.346 44.8106 11.982C44.8386 11.618 44.8526 11.3053 44.8526 11.044C44.8526 10.7827 44.8386 10.47 44.8106 10.106C44.7919 9.742 44.7313 9.392 44.6286 9.056C44.5259 8.72 44.3673 8.43533 44.1526 8.202C43.9379 7.96867 43.6439 7.852 43.2706 7.852C42.8879 7.852 42.5893 7.96867 42.3746 8.202C42.1693 8.43533 42.0153 8.72 41.9126 9.056C41.8099 9.392 41.7446 9.742 41.7166 10.106C41.6979 10.47 41.6886 10.7827 41.6886 11.044ZM51.43 8.44L49.442 10.19L48.252 8.818L51.486 6.088H53.446V16H51.43V8.44Z"
              fill="url(#paint0_linear)"
            />
            <rect
              x="1"
              y="1"
              width="62"
              height="21"
              rx="1"
              stroke="url(#paint1_linear)"
              strokeWidth="2"
            />
            <circle cx="4" cy="12" r="1" fill="url(#paint2_linear)" />
            <circle cx="57" cy="12" r="1" fill="url(#paint3_linear)" />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1="7.33333"
                y1="14.5"
                x2="62.8014"
                y2="12.0496"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2575FC" />
                <stop offset="1" stopColor="#00ECBC" />
              </linearGradient>
              <linearGradient
                id="paint1_linear"
                x1="0.727273"
                y1="10.5"
                x2="63.2976"
                y2="9.17716"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2575FC" />
                <stop offset="1" stopColor="#20DAB0" />
              </linearGradient>
              <linearGradient
                id="paint2_linear"
                x1="3"
                y1="12"
                x2="5.5"
                y2="12"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2575FC" />
                <stop offset="1" stopColor="#00ECBC" />
              </linearGradient>
              <linearGradient
                id="paint3_linear"
                x1="54.5"
                y1="12.5"
                x2="58.5"
                y2="11.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2575FC" />
                <stop offset="0.973958" stopColor="#00ECBC" />
              </linearGradient>
            </defs>
          </svg>
        )}
      </div>
    </span>
  );
};

Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  height?: any;
  width?: any;
  incidents?: boolean;
  explorer?: boolean;
  administration?: boolean;
  supervision?: boolean;
  exportFilePDF?: boolean;
  logout?: boolean;
  link?: boolean;
  upload?: boolean;
  user?: boolean;
  exportCamera?: boolean;
  color?: string;
  adminSettings?: boolean;
  filtre?: boolean;
  lapiincons?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/svg/component.tsx